import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { FiLogOut } from "react-icons/fi";
import { bypassAuth } from "../Auth/auth0Config";

type SidebarLogoutProps = {
	isCollapsed: boolean;
};

/** Auth0 logout button displayed in the sidebar with collapsed mode. */
export function SidebarLogout({ isCollapsed }: SidebarLogoutProps): React.ReactElement {
	const { logout } = useAuth0();

	// Under bypass-auth there is no Auth0 session and the domain is a placeholder, so calling
	// logout() would redirect to https://<placeholder>/v2/logout. Just return to the login screen.
	const handleLogout = () => {
		if (bypassAuth) {
			window.location.href = window.location.origin;
			return;
		}
		logout({ logoutParams: { returnTo: window.location.origin } });
	};

	return (
		<button
			type="button"
			onClick={handleLogout}
			className={`flex w-full items-center gap-3 rounded-xl px-4 py-3 text-base font-semibold text-slate-600 transition hover:bg-slate-100 ${
				isCollapsed ? "justify-center px-3" : ""
			}`}
			title="Logout"
		>
			<FiLogOut className="h-5 w-5 shrink-0" />
			<span className={isCollapsed ? "hidden" : "block"}>Logout</span>
		</button>
	);
}
